export default ({ updated_at, url }) => ({
  url,
  updatedAt: updated_at,
});
